import { FlattenSimpleInterpolation, css } from 'styled-components';

interface IStylesForMaxLinesOfText {
  maxLines: number;
  lineHeight: number;
  fontSizeInRem: number;
  overridingStyles?: FlattenSimpleInterpolation;
  useFullHeight?: boolean;
}

export const stylesForMaxLinesOfText = ({
  maxLines,
  lineHeight,
  fontSizeInRem,
  overridingStyles,
  useFullHeight,
}: IStylesForMaxLinesOfText) => {
  const calculatedHeightRems = maxLines * fontSizeInRem * lineHeight;
  return css`
    /* clamp the text at <maxLines> lines */
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${maxLines};

    line-height: ${lineHeight};
    font-size: ${fontSizeInRem}rem;
    /* The max height is constrained to the per-line height (font size * line height)
     * multiplied by the max number of lines. End result is measured in rems.
     */
    max-height: ${calculatedHeightRems}rem;
    height: ${useFullHeight ? `${calculatedHeightRems}rem` : 'auto'};

    ${overridingStyles || null}
  `;
};
